import React from "react";
import { useParams } from "react-router-dom";

const SubHeaderMenu = ({ location ,title }) => {
  const MenuTitle = [
    {
      path: "/dashboard",
      title: "Dashboard",
    },
    {
      path: "/MyProfile",
      title: " My Profile",
    },
    {
      path: "/kyc_verification",
      title: "Kyc Verification",
    },
    {
      path: "/view_detail",
      title:` ${title}`|| "View Detail",
    },
    {
      path: "/marchant_overview",
      title: "Merchant Overview",
    },
    {
      path: "/marchant_overview/detail",
      title: "Merchant Overview",
    },
    {
      path: "/merchant_transection",
      title: "Transaction & Wallet",
    },
    {
      path: "/card-offer_management",
      title: "Card Offer",
    },
    {
      path: "/banner-offer_management",
      title: "Banner Offer",
    },
    {
      path: "/customer_list",
      title: "Customer List",
    },
    {
      path: "/customer_overview/detail",
      title: "Customer Overview",
    },
    {
      path: "/enquiries",
      title: "Enquiries",
    },
    {
      path: "/myTransection",
      title: "My Transection",
    },
    
    {
      path: "/wallet",
      title: "Wallet",
    },
    {
      path: "/cashFuseOffer",
      title: "Cash Fuse Offer",
    },
    {
      path: "/addOffer",
      title: "Add Offer",
    },
    {
      path: "/conditions",
      title: "Terms & Conditions",
    },
    {
      path: "/help",
      title: "Help",
    },
    {
      path: "/createbanner",
      title: "CashFuse Offer",
    },
    {
      path: "/offer_management",
      title: "Offer Management",
    },
    {
      path: "/case_fuse_offer",
      title: "Cash Fuse Offer",
    },
  ];
  const pathname = location.pathname;
  const params = useParams();

  const current_title = MenuTitle.filter((menu) => pathname === menu.path);
  return <>{current_title.length > "0" ? current_title[0].title : params ? "landing Page" : "Cash Fuse Page"}</>;
};

export default SubHeaderMenu;
